import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        heading: {
            fontSize: theme.typography.subtitle1.fontSize,
            color: theme.palette.primary.dark,
        },
    })
);
